// extracted by mini-css-extract-plugin
module.exports = {"container":"legalityKey_container__HYctM","label":"legalityKey_label__iXHSa"};